import React from 'react';
import { useState } from "react";
import PlannerElementSmol from "./PlannerElementSmol";
import { useData } from "../../DataContext/DataProvider"

function PlannerCalendar({ activeDate, setActiveDate, handleOutsideClick }) {

    const todayDate = new Date();
    const [monthIndex, setMonthIndex] = useState(0)
    const [daysArray, setDaysArray] = useState(getDaysArray(monthIndex))
    const dataContext = useData();
    const [monthBuffer, setMonthBuffer] = useState({
        low: -6,
        high:6
    })

    /**
     * get the array that shows the days in the calendar
     * [{
     * elementDate:date
     * greyout:bool
     * }]
     */
    function getDaysArray (newMonthInd) {
        var numRows = 6;

        const currentMonth = todayDate.getMonth() + newMonthInd;

        var firstDay = new Date(todayDate.getFullYear(), currentMonth, 1).getDay()
        if (firstDay === 0)//js date day is sunday = 0, which cannot be allowed by any reasonable person
            firstDay = 7;

        const emptyDaysArray = new Array(7 * numRows).fill({});
        const filledDaysArray = emptyDaysArray.map((element, index) => {
            const elementDate = new Date(todayDate.getFullYear(), currentMonth, index - firstDay + 2);
            
            return {
                elementDate: elementDate,
                greyOut: elementDate.getMonth() !== (currentMonth % 12)//elementDate.getMonth returns 0-12, current month returns (previous month +- 1) so you can end up overflowing the 0-12 values
            };
        });
        return filledDaysArray
    }


    const monthBufferChange = (newMonthInd) => {
        if (newMonthInd >= monthBuffer.low && newMonthInd <= monthBuffer.high)
            return null
        else {
            var newMonthBuffer = { ...monthBuffer };
            let newMonthBufferStart = 0;
            if (newMonthInd < monthBuffer.low){
                newMonthBuffer.low -= 6
                newMonthBufferStart = newMonthBuffer.low;
            }
            else if (newMonthInd > monthBuffer.high) {
                newMonthBufferStart = newMonthBuffer.high;
                newMonthBuffer.high += 6
            }

            setMonthBuffer(newMonthBuffer);
            const newMonthQuery = {
                start: newMonthBufferStart,
                length: 6
            }
            return newMonthQuery;
        }
    }

    const changeMonthInd = (monthModifier) => {
        const newMonthInd = monthIndex + monthModifier;
        setMonthIndex(newMonthInd)
        const isMonthBufferChange = monthBufferChange(newMonthInd)
        if (isMonthBufferChange) {
            dataContext.planData.getNewPlans(isMonthBufferChange.start)
        }
        setDaysArray(getDaysArray(newMonthInd))
    }

    return (
        <div className="planner-calendar-container columns">
            <div className="month-navigator hoverable-element">
                <button className="button" onClick={() => changeMonthInd(-1)}>{"Prev"} </button> 
                <p className="month-string">{new Date(todayDate.getFullYear(), todayDate.getMonth() + monthIndex, 1).toLocaleDateString('default', { month: 'long', year:'numeric'})}</p>
                <button className="button" onClick={() => changeMonthInd(1)}>{"Next"} </button> 
            </div>
            <ul className={activeDate ? "calendar-container-element min-height" : "calendar-container-element max-height"}>
                <li className="calendar-day-element planner-page-element">Mon</li>
                <li className="calendar-day-element planner-page-element">Tue</li>
                <li className="calendar-day-element planner-page-element">Wed</li>
                <li className="calendar-day-element planner-page-element">Thu</li>
                <li className="calendar-day-element planner-page-element">Fri</li>
                <li className="calendar-day-element planner-page-element">Sat</li>
                <li className="calendar-day-element planner-page-element">Sun</li>
                {
                    daysArray?.map((dayInfo, index) => {
                        return (
                            <li className={dayInfo.greyOut ? "calendar-date-element planner-page-element grey-out" : "calendar-date-element planner-page-element hoverable-element"} key={index}
                                onClick={() => {
                                    if (!dayInfo.greyOut) {
                                        setActiveDate(daysArray[index].elementDate)
                                        document.addEventListener("mousedown", handleOutsideClick)
                                    }
                                }}>
                                <PlannerElementSmol elementDate={dayInfo.elementDate} />
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
}

export default PlannerCalendar